import { CAlert, CCol, CModal } from '@coreui/react'
import React from 'react'
import { Field, Form } from 'react-final-form'
import { connect } from 'react-redux'

import { ErrorToast, SuccesToast } from 'src/components/toaster'
import { MultiRequest } from 'src/store/actions/multicontent'
import { renderFieldForm, required } from 'src/helpers/column/Pemakaian/Tambah'

import range from 'lodash.range'
import CustomRenderSelect from '../SelectTanggal'
import { toTanggal } from 'src/module/helpers'

// import { config } from 'src/helpers/request'
import { toSnakeCase } from 'src/views/Mitra/helper'
import CalculateForm from 'final-form-calculate'
import createDecorator from 'final-form-focus'
import { parseNik } from 'src/module/helpers'
import { validateNIK } from 'src/components/TextMask'
import { EditPelangganValidator, TambahPelangganValidator } from 'src/components/Hapus'

import { updateDataForm } from 'src/components/GeneratorForm'
import { SupendLoading } from 'src/App'

import { ObjToArrayString, getChanges } from 'src/module/helpers'
// import { EditPelangganValidator } from 'src/components/Hapus'
import { getParams } from '.'

const GalatComponent = React.lazy(() => import(/* webpackPrefetch: true */'src/components/GalatComponent'))
const ImageComponent = React.lazy(() => import(/* webpackPrefetch: true */'src/components/ImageComponent.js'))

const Loader = React.lazy(() => import(/* webpackPrefetch: true */'src/components/Loader'))

const focusOnError = createDecorator();


export const to_str_layanan = (state, value) => {
  return state?.data?.id_layanan
    ?.filter((item) => Number(item.value) === Number(value))
    .reduce(
      (prev, next) => ({
        ...prev,
        ...next,
      }),
      {},
    )
}

export const range_tanggal_penagihan = range(1, 29, 1).map((item) => ({
  value: item,
  label: item,
}))

const _form_disabled = ['username', 'password', 're_password']

export const formPelanggan = (method) => [
  {
    layOut: 'formGroupVerticalAndLabel',
    content: [
      {
        name: 'nama_lengkap',
        label: 'Nama Pelanggan',
        type: 'text',
        validate: required('Nama Pelanggan'),
        layOut: 'formGroupHorizontal',
        size: 'sm',
        focus: true,
      },
      {
        name: 'nik',
        label: 'NIK',
        type: 'mask',
        validate: validateNIK,
        layOut: 'formGroupHorizontal',
        size: 'sm',
      },
      {
        name: 'tanggal_registrasi',
        type: 'date',
        label: 'Tanggal Registrasi',
        size: 'sm',
        data: [],
        layOut: 'formGroupHorizontal',
        customRender: <CustomRenderSelect />,
        validate: required('Tanggal Registrasi'),
      },
    ],
  },

  {
    layOut: 'formGroupVerticalAndLabel',
    size: 'sm',
    content: [
      {
        name: 'tempat_lahir',
        label: 'Tempat Lahir',
        type: 'text',
        validate: required('Tempat Lahir'),
        layOut: 'formGroupHorizontal',
        size: 'sm',
      },
      {
        name: 'tanggal_lahir',
        label: 'Tanggal Lahir',
        type: 'date',
        validate: required('Tanggal Lahir'),
        layOut: 'formGroupHorizontal',
        size: 'sm',
      },
      {
        name: 'jenis_kelamin',
        label: 'Jenis Kelamin',
        type: 'select',
        placeholder: 'Jenis Kelamin',
        data: [
          { value: 1, label: 'Laki-Laki' },
          { value: 2, label: 'Perempuan' },
        ],
        validate: required('Jenis Kelamin'),
        layOut: 'formGroupHorizontal',
        size: 'sm',
      },
    ],
  },

  {
    name: 'alamat',
    type: 'textarea',
    label: 'Alamat Domisili/Alamat Tinggal',
    layOut: 'formGroupHorizontal',
    validate: required('Alamat Domisili/ Alamat Tinggal'),
    size: 'sm',
    rows: '3',
  },
  {
    layOut: 'formGroupVerticalAndLabel',
    content: [
      {
        name: 'no_hp',
        label: 'No. HP',
        type: 'phone',
        size: 'sm',
        placeholder: 'Tuliskan beserta kode negara (62)',
        layOut: 'formGroupHorizontal',
        validate: required('Nomor Hape'),
      },
      {
        name: 'tanggal_penagihan',
        type: 'select',
        placeholder: '--- Pilih Tanggal Jatuh Tempo ---',
        data: range_tanggal_penagihan,
        label: 'Tanggal Penagihan',
        readOnly: method === 'edit',
        size: 'sm',
        layOut: 'formGroupHorizontal',
        validate: required('Tanggal Penagihan'),
      },
      {
        name: 'id_status',
        type: 'select',
        placeholder: '--- Pilih Status ---',
        data: [],
        label: 'Status Pelanggan',
        size: 'sm',
        readOnly: method === 'edit',
        layOut: 'formGroupHorizontal',
        validate: required('Status Pelanggan'),
      },
      {
        name: 'id_kasir',
        type: 'select',
        placeholder: '--- Pilih Kasir ---',
        data: [],
        label: 'Kasir',
        size: 'sm',
        readOnly: method === 'edit',
        layOut: 'formGroupHorizontal',
        // validate: required('Kasir'),
      },
    ],
  },
  {
    layOut: 'formGroupVerticalAndLabel',
    content: [
      {
        name: 'jenis_penagihan',
        type: 'select',
        label: 'Jenis Penagihan',
        size: 'sm',
        data: [
          {
            value: 'prabayar',
            label: 'Prabayar',
          },
          {
            value: 'pascabayar',
            label: 'Pascabayar',
          },
        ],
        placeholder: '--- Pilih Penagihan ---',
        layOut: 'formGroupHorizontal',
        validate: required('Jenis Packet'),
      },


      {
        name: 'id_layanan',
        type: 'select',
        label: 'Packet',
        size: 'sm',
        data: [],
        placeholder: '--- Pilih Packet ---',
        layOut: 'formGroupHorizontal',
        readOnly: method === 'edit',
        validate: required('Jenis Packet'),
      },
      {
        name: 'id_trigger',
        type: 'select',
        label: 'Trigger',
        size: 'sm',
        data: [],
        placeholder: '--- Pilih Trigger ---',
        layOut: 'formGroupHorizontal',
      },

      ...(method === 'edit'
        ? [
          {
            name: 'gratis_satu_bulan_pertama',
            type: 'select',
            label: 'Gratis satu bulan pertama',
            size: 'sm',
            data: [
              { label: 'Ya', value: 1 },
              { label: 'Tidak', value: 2 },
            ],
            placeholder: '--- Pilih ---',
            layOut: 'formGroupHorizontal',
            validate: required('Jenis Packet'),
          },
        ]
        : []),
    ],
  },

  {
    layOut: 'formGroupVerticalAndLabelCalout',
    label: 'Buatkan user login untuk masuk ke System sebagai pelanggan',
    content: [
      {
        name: 'username',
        type: 'text',
        label: 'Username',
        readOnly: true,
        data: [],
        placeholder: '--- Pilih Packet ---',
        layOut: 'formGroupHorizontal',
        size: 'sm',
        // validate: usernameAvailable,
      },
      {
        name: 'password',
        type: 'password',
        label: 'Kata Sandi',
        data: [],
        placeholder: 'Kata Sandi Pengguna',
        layOut: 'formGroupHorizontal',
        validate: required('Kata Sandi'),
        size: 'sm',
      },
      {
        name: 're_password',
        type: 'password',
        label: 'Konfirmasi Kata Sandi',
        data: [],
        layOut: 'formGroupHorizontal',
        validate: required('Pengulangan Kata Sandi'),
        size: 'sm',
      },
    ],
  },
]

export const renderImageComponent = ({ input, meta, title, imagePreview }) => {
  return (
    <ImageComponent
      title={title}
      imagePreview={imagePreview}
      inputProps={input}
      meta={meta}
      width="20rem"
      BgClassName="foto_tambah_pelanggan"
    />
  )
}

class TambahPelanggan extends React.Component {
  constructor(props) {
    super(props)

    const params = getParams()

    this.state = {
      visibleLg: true,
      initialValues: {},
      data: {},
      method: params?.method || 'new',
      page: 0,
    }

    this.getDataIdPelDanLayanan(params)
  }

  getDataIdPelDanLayanan = (params) => {
    const { dispatch, id_reseller, id_mitra } = this.props

    const _params = {
      ...params,
      id_mitra,
      id_reseller,
      ...(params.id_pelanggan &&
        params?.method === 'edit' && {
        id_pelanggan: params?.id_pelanggan,
      }),
    }
    const query = new URLSearchParams(_params)

    dispatch(
      MultiRequest('tambah_pelanggan', {
        method: 'get',
        url: `/administrasi/tambah_pelanggan?${query.toString()}`,
      }),
    )
  }

  galatHandle = () => {
    this.getDataIdPelDanLayanan(this.state.params)
  }

  componentDidUpdate(prevProps) {
    const { appSetting } = this.props

    if (prevProps.axiosTemp['tambah_pelanggan'] !== this.props.axiosTemp['tambah_pelanggan']) {
      if (
        this.props.axiosTemp['tambah_pelanggan'].status === 'error' &&
        this.props.axiosTemp['tambah_pelanggan'].lastaction.method === 'get'
      ) {
        ErrorToast('Pengambilan data pertama pada pelanggan gagal')
      }
      if (this.props.axiosTemp['tambah_pelanggan'].status === 'success') {
        const {
          axiosTemp: { tambah_pelanggan },
        } = this.props
        const { response } = tambah_pelanggan
        // console.log(response)
        let { id_layanan, trigger, id_status, id_kasir } = response

        const initialValues = response?.initialValues

        id_layanan = id_layanan.map((item) => ({
          label: `${item.layanan}`,
          value: item.id_layanan,
        }))

        const nama_lengkapElement = document.getElementsByName('nama_lengkap')
        if (nama_lengkapElement) {
          nama_lengkapElement[0].focus()
          // console.log(nama_lengkapElement)
        }

        this.setState({
          state_gratis_satu_bulan_pertama: this.state.initialValues?.state_gratis_satu_bulan_pertama,
          initialValues: {
            tanggal_penagihan: appSetting?.default_tanggal_tagihan,
            ...(response.last_id_pelanggan && {
              id_pelanggan: response.last_id_pelanggan,
            }),

            ...(initialValues && {
              ...initialValues,
            }),
          },
          data: {
            id_layanan,
            id_trigger: trigger,
            id_status,
            id_kasir
          },
        })
      }
    }
    // console.log(this.props)
    if (
      prevProps.axiosTemp[this.props.selectorRedux] !==
      this.props.axiosTemp[this.props.selectorRedux]
    ) {
      if (
        this.props.axiosTemp[this.props.selectorRedux].status === 'error' &&
        this.props.axiosTemp[this.props.selectorRedux].lastaction?.method === 'post'
      ) {
        const m =
          this.state.method === 'edit'
            ? 'Pengubahan data pelanggan gagal '
            : 'Penambahan data pelanggan gagal'
        const { response } = this.props.axiosTemp[this.props.selectorRedux]

        ErrorToast(response?.data?.message || m, 'top-center')
      }
      if (
        this.props.axiosTemp[this.props.selectorRedux].status === 'success' &&
        this.props.axiosTemp[this.props.selectorRedux].lastaction?.method === 'post'
      ) {
        this.setState({ visibleLg: false })

        // history.push({
        //     pathname: location.pathname
        // });

        SuccesToast(
          `${this.state.method === 'new' ? 'Penambahan' : 'Ubah'} data pelanggan  berhasil`,
          'top-center',
        )
      }
    }
  }
  onSubmit = async (initialValues) => {
    const { dispatch, id_reseller, id_mitra, actions, params } = this.props
    let tambah_val = {}

    if (params?.method === 'edit') {

      const objectChange = getChanges(this.state.initialValues, initialValues)

      if (
        'gratis_satu_bulan_pertama' in objectChange &&
        this.state.initialValues?.state_gratis_satu_bulan_pertama === 'read_only'
      ) {
        return ErrorToast(
          'Anda tidak dapat merubah gratis satu bulan pertama, di karenakan user sudah memiliki tagihan berjalan',
          'top-center',
        )
      }

      if (
        'tanggal_registrasi' in objectChange &&
        this.state.initialValues?.state_gratis_satu_bulan_pertama === 'read_only'
      ) {
        return ErrorToast(
          'Anda tidak dapat merubah tanggal registrasi, di karenakan user sudah memiliki tagihan berjalan',
          'top-center',
        )
      }

      if (Object.keys(objectChange).length === 0)
        return ErrorToast('Anda tidak merubah data apapun', 'top-center')

      const _initialValueStr = {
        ...objectChange,
        ...('id_layanan' in objectChange && {
          id_layanan: to_str_layanan(this.state, objectChange?.id_layanan)?.label,
        }),
      }
      const _html = ObjToArrayString(_initialValueStr).join('<br />')

      tambah_val = await EditPelangganValidator(
        `Anda telah merubah data ${_html}, Klik ya untuk menyimpan perubahan dan klik tidak untuk kembali`,
      )
    }

    if (params?.method === 'new') {
      tambah_val = await TambahPelangganValidator()
    }

    const isConfirmed = tambah_val?.isConfirmed
    const isDismissed = tambah_val?.isDismissed

    if (isDismissed) return

    const gratis_satu_bulan_pertama = isConfirmed

    const _nik = initialValues?.nik?.replace(/-/gi, '')

    dispatch(
      MultiRequest(this.props.selectorRedux, {
        method: 'post',
        url: '/administrasi/tambah_pelanggan',
        dataPost: {
          data: {
            id_mitra,
            id_reseller,
            ...initialValues,
            ...(initialValues.tanggal_registrasi && {
              tanggal_registrasi: toTanggal(
                initialValues.tanggal_registrasi,
                'YYYY-MM-DD HH:mm:ss',
              ),
            }),
            nik: _nik,
            ...(params?.method === 'new' && {
              gratis_satu_bulan_pertama: gratis_satu_bulan_pertama ? 1 : 2,
            }),
          },
          method: this.state.method,
          actions: actions || 'to_table',
          status: params?.status
        },
      }),
    )
  }
  onClose = () => {
    const { history } = this.props
    history.goBack();
  }

  onPageChange = (page) => {
    this.setState({
      page,
    })
  }

  closeHandle = () => {
    this.props?.history?.goBack()
  }

  render() {
    const { visibleLg } = this.state
    const { initialValues, axiosTemp, selectorRedux, id_reseller, params } = this.props

    // console.log(this.state.data)

    const _form = updateDataForm(
      formPelanggan(params?.method),
      this.state.data,
      params?.method,
      _form_disabled,
      ['id_layanan', 'id_trigger', 'id_status', 'id_kasir'],
    )

    const is_modal = true

    const isGalat = this.props.axiosTemp['tambah_pelanggan']?.status === 'error' &&
      this.props.axiosTemp['tambah_pelanggan']?.lastaction?.method === 'get'

    const isRunning = this.props.axiosTemp['tambah_pelanggan']?.status === 'running';



    const initialValuesFromParams = () => {
      const allowed_value_stat = ['antrian', 'active', 'non_aktif']
      if (!params) return {}
      if (params?.status) {
        if (!allowed_value_stat.includes(params?.status)) return {}
        const renderStatus = (sta) => {
          switch (sta) {
            case "non_aktif":
              return "Non Aktif"
            case "active":
              return "Aktif"
            case "antrian":
              return "Antrian"
            default:
              break;
          }
        }
        return {
          status: renderStatus(params?.status)
        }
      }
      return {}
    }

    const _initialValues = initialValuesFromParams()

    // console.log(params)

    const calculator = CalculateForm(
      {
        field: 'id_pelanggan', // when minimum changes...
        updates: {
          username: (itemValue, allValues) => {
            return params?.method === 'edit' ? allValues.username : toSnakeCase(itemValue)
          },
        },
      },
      {
        field: 'username', // when minimum changes...
        updates: {
          username: (itemValue, allValues) => {
            return params?.method === 'edit' ? allValues.username : toSnakeCase(itemValue)
          },
        },
      },
      {
        field: 'nik', // when minimum changes...
        updates: async (value, name, allValues) => {
          const toField = await parseNik(value)
          if (toField && params?.method === 'new') {
            return toField
          }

          return {}
        },
      },
    )

    // console.log(id_reseller)

    return (
      <React.Fragment>
        <style jsx="true">{``}</style>

        <CModal
          className={!is_modal ? 'show d-block position-static' : ''}
          backdrop={!is_modal ? false : 'static'}
          size={'xl'}
          visible={!is_modal ? true : visibleLg}
          keyboard={!is_modal && false}
          portal={!is_modal && false}
          onClose={this.onClose}
        >
          {axiosTemp[selectorRedux]?.status === 'running' && <Loader />}
          {isRunning && <Loader />}
          {isGalat && (
            <React.Suspense fallback={SupendLoading}>
              <GalatComponent galatHandle={this.galatHandle} closeHandle={this.closeHandle} />
            </React.Suspense>
          )}
          <div className="w-100 p-2 d-flex align-items-end bg-primary rounded-top rounded-end">
            <span className="text-white fw-bolder">
              {!id_reseller && (
                <div>{this.state.method === 'edit' ? 'Ubah' : 'Tambah'} Pelanggan</div>
              )}
              {id_reseller && (
                <div>
                  {this.state.method === 'edit' ? 'Ubah' : 'Tambah'} Pelanggan{' '}
                  {id_reseller ? `[${id_reseller}]` : ''}
                </div>
              )}
            </span>
            <div className="ms-auto">
              <button
                className="btn-close btn-close-white fw-bolder"
                onClick={() => this.onClose()}
              ></button>
            </div>
          </div>

          <Form
            initialValues={{
              ...this.state.initialValues,
              ...initialValues,
              ..._initialValues
            }}
            decorators={[focusOnError, calculator]}
            validate={(values) => {
              const errors = {}
              if (!values.password) {
                errors.password = 'Perlu di isi'
              } else if (values.re_password !== values.password) {
                errors.re_password = 'Kata sandi pengulangan anda salah.'
              }
              return errors
            }}
            onSubmit={this.onSubmit}
            render={({ handleSubmit, form, submitting, pristine, values }) => (
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="row gx-1">
                    <div className="col-sm-4 mb-1">
                      <Field
                        name="foto_pelanggan"
                        title="Foto Pelanggan"
                        component={renderImageComponent}
                      />

                      <div className="mt-4">
                        <Field
                          name="document"
                          title="Foto KTP"
                          component={renderImageComponent}
                          imagePreview="/images/ktp.png"
                        />
                      </div>
                    </div>
                    <div className="col-sm-8 mb-1">
                      <div className="card bg-light">
                        <div className="card-body pt-0">
                          <div className="d-flex flex-row-reverse mb-2">
                            <span className="fw-bolder me-2">
                              ID Pelanggan: {this.state.initialValues?.id_pelanggan}
                            </span>
                          </div>

                          {/*  // eslint-disable-next-line array-callback-return */}
                          {_form.map((item, index) => {
                            if (item.content && item.layOut === 'formGroupVerticalAndLabel') {
                              return (
                                <React.Fragment>
                                  <div className="row gx-1">
                                    {item.content?.map((xContent, xIndex) => (
                                      <div
                                        className={`col-sm-${12 / item.content.length}`}
                                        key={index}
                                      >
                                        <div className={'mb-1'}>
                                          <Field
                                            key={`tb_pelanggan-${xIndex}`}
                                            layOut={xContent.layOut}
                                            item={xContent}
                                            metatype={xContent.type}
                                            name={xContent.name}
                                            component={renderFieldForm}
                                            customRender={xContent.customRender}
                                            readOnly={xContent.readOnly}
                                            validate={xContent.validate}
                                            className={`col-sm-${12 / item.content.length}`}
                                            autoFocus={xContent.focus}
                                          />
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </React.Fragment>
                              )
                            }
                            if (item.content && item.layOut === 'formGroupVerticalAndLabelCalout') {
                              return (
                                <CAlert color="success mt-1 border border-light">
                                  <small>{item?.label}</small>
                                  <br />
                                  <React.Fragment>
                                    <div className="row gx-1 mt-2">
                                      {item.content?.map((xContent, xIndex) => (
                                        <div
                                          className={`col-sm-${12 / item.content.length}`}
                                          key={`tb_pelanggan-c-${xIndex}`}
                                        >
                                          <div className={'mb-1'}>
                                            <Field
                                              key={`tb_pelanggan-c-${xIndex}`}
                                              layOut={xContent.layOut}
                                              item={xContent}
                                              metatype={xContent.type}
                                              name={xContent.name}
                                              component={renderFieldForm}
                                              customRender={xContent.customRender}
                                              readOnly={xContent.readOnly}
                                              validate={xContent.validate}
                                              className={`col-sm-${12 / item.content.length}`}
                                            />
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </React.Fragment>
                                </CAlert>
                              )
                            }
                            if (item.layOut === 'formGroupHorizontal') {
                              return (
                                <Field
                                  validate={item.validate}
                                  item={item}
                                  key={`tb_pelanggan-a-${index}`}

                                  metatype={item.type}
                                  name={item.name}
                                  layOut={item.layOut}
                                  component={renderFieldForm}
                                  readOnly={item.readOnly}
                                  customRender={item.customRender}
                                />
                              )
                            }
                            return <span key={index} />
                          })}

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <CCol xs="auto">
                    <div className="btn-group" role="group">
                      <button className="btn btn-primary" type="submit" disabled={submitting}>
                        {this.state.method === 'ubah' ? 'Ubah' : 'Simpan'}
                      </button>
                      <button
                        type="button"
                        className="btn btn-success"
                        disabled={submitting || pristine}
                      >
                        Kembali
                      </button>
                    </div>
                  </CCol>
                </div>
              </form>
            )}
          />
        </CModal>
      </React.Fragment>
    )
  }
}

const MapStateToProps = ({ axiosTemp, app_setting }) => ({
  axiosTemp,
  appSetting: app_setting?.response,
})

TambahPelanggan.defaultProps = {
  selectorRedux: 'pelanggan_new',
}

const toMemoComponent = connect(MapStateToProps)(TambahPelanggan)

export default React.memo(toMemoComponent)
